import React, { Component } from 'react';
import axios from 'axios';
import './CyberRepo.css'

export default class CyberRepo extends Component {

    constructor(props) {
        super(props);
        const name = "CyberRepo";

        const lang = window.location.href.indexOf("/en/") > -1 ? {
            type: {
                description: 'Type',
                posters: 'Placards and posters',
                iconography : 'Iconography',
                showpiece : 'Books',
                musical_prints : 'Musical prints',
            },
            date: {
                description: 'Date'
            },
            sort: {
                description: "Sort by",
                title: "Title",
                chronological : 'Chronological'
            }
        } : {
            type: {
                description: 'Typ',
                posters: 'Afisze i plakaty',
                iconography : 'Ikonografia',
                showpiece : 'Książki',
                musical_prints : 'Druki muzyczne',
            },
            date: {
              description: 'Data'
            },
            author: {
                description: 'Autor'
            },
            sort: {
                description: "Sortuj po",
                title: "Tytuł",
                chronological : 'Chronologicznie'
            }
        }

        this.state = {
            data: this.props.data.list,
            advancedMode: false,
            limit: 54,
            counter: 0,
            keyword: false,
            noMore: false,
            showClear: false,
            advancedSearch: lang
        };

        //console.log(name, "props: ", this.props.data);
    }

    updateKeyWord = e => {
        this.setState({
            keyword: e.target.value
        })
    }
    
    clear = () => window.location.reload();

    updateData = e => {
        if(e){
            e.preventDefault();
        }

        let limit = this.state.limit;
        let offset = limit;
        let counter = this.state.counter;

        let link = `${this.props.data.button_lazy_load.url}?lang=${this.props.data.button_lazy_load.lang}&offset=${offset * counter}&limit=${limit+1}`;
        //{console.log(link)}
        axios
            .post(link, "search=" + `{"keyword":"${this.state.keyword}"}`)
            .then(res => {
                //console.log((link),"link");
                const data = res.data.list;
                this.setState({
                    showClear: true
                })
                if (data && data.length) {
                    if(data.length > limit) {
                        this.setState({
                            data: data.slice(0, limit),
                            noMore: false,
                        })
                    } else {
                        this.setState({
                            data: data.slice(0, limit),
                            noMore: true,
                        })
                    }
                } else {
                    this.setState({
                        data: [],
                        noMore: true,
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    isVisible: false
                })
            })
    }

    concatData = e => {
        if (e) {
            e.preventDefault();
        }

        let limit = this.state.limit;
        let offset = limit;
        let counter = this.state.counter;

        let link = `${this.props.data.button_lazy_load.url}?lang=${this.props.data.button_lazy_load.lang}&offset=${offset * counter}&limit=${limit + 1}`;

        axios
            .post(link, "search=" + `{"keyword":"${this.state.keyword ? this.state.keyword : ''}"}`)
            .then(res => {
                //console.log(res);
                const data = res.data.list;
                if (data && data.length) {
                    this.setState({
                        ...this.state,
                        data: this.state.data.concat(data.slice(0, limit))
                    })
                }

                if (data.length <= limit) {
                    this.setState({
                        noMore: true,
                    })
                }
            })
            .catch((error) => {
                this.setState({
                    isVisible: false
                })
            })
    }

    moreData = () => {
        this.setState({
            counter: this.state.counter + 1
        }, () => {
            this.concatData()
        })
    }


    render() {

         const toggleMenu = e =>{
             e.preventDefault();
             this.setState({
                 advancedMode: !this.state.advancedMode
             })
             //console.log(this.state.advancedMode);
         }

        return (
            <div id="repository">
                <h1>{this.props.data.title}</h1>
                {this.props.data.list_view ? null : (
                    <form onSubmit={this.updateData}>
                        <div style={{position: 'relative'}}>
                            <input id="repo-text" type="text" onChange={this.updateKeyWord} />
                            <button className="input-search"></button>
                        </div>
                        <button className={this.state.showClear ? "clear-btn-search" : "clear-btn-search-none"}
                                onClick={this.clear}>{window.location.href.indexOf("/en/") > -1 ? `Clear search` : `Wyczyść wyszukanie`}
                        </button>
                         <div style={{textAlign: 'right'}}>
                            <button className="show-advanced" onClick={toggleMenu}>Wyszukiwanie zaawansowane</button>
                        </div>
                        {/*<div className={`advanced-box ${this.state.advancedMode ? "open" : ""}`}>
                            <label>{this.state.advancedSearch.type.description}</label>
                            <div className="tags-wrapper">
                                <div>{this.state.advancedSearch.type.iconography}</div>
                                <div>{this.state.advancedSearch.type.musical_prints}</div>
                                <div>{this.state.advancedSearch.type.posters}</div>
                                <div>{this.state.advancedSearch.type.showpiece}</div>
                            </div>
                            <div>
                                <label>{this.state.advancedSearch.date.description}</label>
                                <input id="repo-text" type="text" onChange={this.updateKeyWord} />
                                <label>{this.state.advancedSearch.author.description}</label>
                                <input id="repo-text" type="text" onChange={this.updateKeyWord} />
                            </div>
                            <label>{this.state.advancedSearch.sort.description}</label>
                            <div className="tags-wrapper">
                                <div>{this.state.advancedSearch.sort.chronological}</div>
                                <div>{this.state.advancedSearch.sort.title}</div>
                            </div>

                            <div>
                                <label>Osoba</label>
                                <div className="fields-wrapper">
                                    <div>Kompozycja: wszystkie</div>
                                    <div>Opus: wszystkie</div>
                                    <div>Miejsce przechowania: wszystkie</div>
                                    <div>Data: wszystkie</div>
                                    <div>Melodia</div>
                                    <div>Medium</div>
                                </div>
                                <div>
                                    <button className="clear-btn">Wyczyść</button>
                                    <button className="search-btn">Wyszukaj</button>
                                </div>
                            </div>
                        </div>*/}
                    </form>
                )}

                <div className={`repo-wrapper `}>
                    {/* <div className="repo-label">Kategorie</div> */}

                    {this.state.data && this.state.data.length ? (
                        this.state.data.slice(0,this.state.limit+this.state.limit*this.state.counter).map((item, index) => {
                            return (
                                <a key={index} href={item.url}>
                                    {/* {this.props.data.list_view ? (
                                        <div className="list-view-item">
                                            <div className="image" key={index} style={{ backgroundImage: `url(${item.obverse_img})` }}></div>
                                            <div>{item.title.length > 70 ? item.title.slice(0, 70)+"..." : item.title}</div>
                                        </div>
                                    ) : ( */}
                                        <div key={index} style={{ backgroundImage: `url(${item.obverse_img})` }}>
                                        <p>{item.title.length > 65 ? item.title.slice(0, 65) + "..." : item.title}<span>{item.count ? `[${item.count}]` : ""}</span></p>
                                        </div>
                                        {/* )} */}
                                </a>
                            )
                        })
                    ) : (
                        <div>
                            {this.state.keyword && this.state.keyword.length ? (
                                <div>
                                    {window.location.href.indexOf("/en/") > -1 ? `No results for keyword: ${this.state.keyword}` : `Brak wyników dla frazy: ${this.state.keyword}`}
                                </div>
                            ) : null}
                        </div>
                    )}
                </div>
                {this.state.noMore ? null : (
                    this.props.data.title !== "Repozytorium cyfrowe" ?
                        <div className="btn-wrapper">
                            <div className="more-btn" style={{ backgroundColor: `#${this.props.bgColor}`}} onClick={this.moreData}>{this.props.data.button_lazy_load.text}</div>
                        </div>
                    : null
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/CyberRepo/index.jsx